import { Component, OnInit, ElementRef } from '@angular/core';
import {  ViewChild } from '@angular/core';

declare var jquery:any;
declare var $ :any;

import * as M from "materialize-css/dist/js/materialize";


import {GetdataService} from '../../services/getdata.service';
import {DeletedataService} from '../../services/deletedata.service';
import {AdddataService} from '../../services/adddata.service';
import {RouterModule,ActivatedRoute, Routes} from '@angular/router';

import {Http, Response, Headers} from '@angular/http';
@Component({
  selector: 'app-southeast-community',
  templateUrl: './southeast-community.component.html',
  styleUrls: ['./southeast-community.component.css']
})
export class SoutheastCommunityComponent implements OnInit {

  totalroomevents:RoomEvents[];
  roomevents_arena:RoomEvents[];
  roomevents_ShooterpadA:RoomEvents[];
  roomevents_ShooterpadB:RoomEvents[];
  roomevents_Commroom1:RoomEvents[];
  roomevents_Commroom2:RoomEvents[];

  public event_array_arena:Event_array_arena[];
  public event_ShooterpadA:Event_array_room[];
  public event_ShooterpadB:Event_array_room[];
  public event_Commroom1:Event_array_room[];
  public event_Commroom2:Event_array_room[];

  public Event_start_time:string[];
  public Event_end_time:string[];
  public Today_date:string;
  public Clock_date:string;

  public Event_room_name:string;

  public Room_Name_URL:string;
  
  public event_counter_arena:number;
  public event_counter_room:number;

  constructor(private route: ActivatedRoute,private getdataService:GetdataService,  private deletedataService:DeletedataService, private adddataService:AdddataService, private http:Http, private elem: ElementRef) {
    setInterval(() => {
       this.refreshData();
    }, 60000);
  

    $("#slideshow > div:gt(0)").hide();

    setInterval(() => { 
      $('#slideshow > div:first')
        .fadeOut(1000)
        .next()
        .fadeIn(1000)
        .end()
        .appendTo('#slideshow');
    },  7000);


   }

  ngOnInit() {
    this.Room_Name_URL = this.route.snapshot.paramMap.get('id');
    this.event_counter_arena=0;
    this.event_counter_room=0;
    $("#slideshow > div:gt(0)").hide();
    this.refreshData();
  }

  format_time= (date_obj) => {
    // formats a javascript Date object into a 12h AM/PM time string
    var hour = date_obj.getHours();
    var minute = date_obj.getMinutes();
    var amPM = (hour > 11) ? "PM" : "AM";
    if(hour > 12) {
      hour -= 12;
    } else if(hour == 0) {
      hour = "12";
    }
    if(minute < 10) {
      minute = "0" + minute;
    }
    return hour + ":" + minute +" "+ amPM;
   }


   refreshData = ()=>{
    console.log("getting data")
      //let account_id = this.route.snapshot.paramMap.get('id');
      //console.log(account_id)
       ////Date////
       var d = new Date();
       var currentDate = d.getTime();
       var currentDate_start = d.setHours(0);
       var currentDate_start = d.setMinutes(0);
       var currentDate_start = d.setSeconds(0);
       var currentDate_end = d.setHours(23);
       var currentDate_end = d.setMinutes(59);
       var currentDate_end = d.setSeconds(59);
    
       this.totalroomevents = [];
   //Meeting Room
   this.getdataService.getGoogleCalendarData('qtqqa224adom3ii1vadv3nuc44@group.calendar.google.com').subscribe((roomevents) => {
    console.log(roomevents)
    for(let i=0; i<roomevents.length ; i++){
      this.totalroomevents.push(roomevents[i])  ;
     }
      //Multipurpose Room
      this.getdataService.getGoogleCalendarData('bncunp6bd95bskdcdaq9b8pt30@group.calendar.google.com').subscribe((roomevents) => {
        console.log(roomevents)
        for(let i=0; i<roomevents.length ; i++){
          this.totalroomevents.push(roomevents[i])  ;
        }
        //Multipurpose Room 1
        this.getdataService.getGoogleCalendarData('bu179o66liuhsi93o5r8h31vl8@group.calendar.google.com').subscribe((roomevents) => {
          console.log(roomevents)
          for(let i=0; i<roomevents.length ; i++){
            this.totalroomevents.push(roomevents[i])  ;
          }
          //Multipurpose Room 2
          this.getdataService.getGoogleCalendarData('fpv5k93opctta15rlr7g1pi9lk@group.calendar.google.com').subscribe((roomevents) => {
            console.log(roomevents)
            for(let i=0; i<roomevents.length ; i++){
              this.totalroomevents.push(roomevents[i])  ;
            }
            //Gymnasium
            this.getdataService.getGoogleCalendarData('9v0tgs7km5bd34pa5qt8071qbs@group.calendar.google.com').subscribe((roomevents) => {
              console.log(roomevents)
              for(let i=0; i<roomevents.length ; i++){
                this.totalroomevents.push(roomevents[i])  ;
              }
              //Gymnasium 1
              this.getdataService.getGoogleCalendarData('9n453a73nesenti6vpudh0f46s@group.calendar.google.com').subscribe((roomevents) => {
                console.log(roomevents)
                for(let i=0; i<roomevents.length ; i++){
                  this.totalroomevents.push(roomevents[i])  ;
                }
                //Gymnasium 2
                this.getdataService.getGoogleCalendarData('j66fsnbhcsoe9kk6pa0bfs7kqo@group.calendar.google.com').subscribe((roomevents) => {
                  console.log(roomevents)
                  for(let i=0; i<roomevents.length ; i++){
                    this.totalroomevents.push(roomevents[i])  ;
                  }
                  //Leisure pool
                  this.getdataService.getGoogleCalendarData('vjo3iuq98vbbjhfs4odv6ttpd4@group.calendar.google.com').subscribe((roomevents) => {
                    console.log(roomevents)
                    for(let i=0; i<roomevents.length ; i++){
                      this.totalroomevents.push(roomevents[i])  ;
                    }
                    //Lap pool
                    this.getdataService.getGoogleCalendarData('3o7sqkrgg1nl5cfvrr99qg78i0@group.calendar.google.com').subscribe((roomevents) => {
                    console.log(roomevents)
                    for(let i=0; i<roomevents.length ; i++){
                      this.totalroomevents.push(roomevents[i])  ;
                    }
                    //Both pools
                    this.getdataService.getGoogleCalendarData('6naua79hpadc6fnq6rhnfsi6a8@group.calendar.google.com').subscribe((roomevents) => {
                      console.log(roomevents)
                      for(let i=0; i<roomevents.length ; i++){
                        this.totalroomevents.push(roomevents[i])  ;
                      }
                      //Fitness Studio
                    this.getdataService.getGoogleCalendarData('7ffssl05ig1akn9paqobvp91c4@group.calendar.google.com').subscribe((roomevents) => {
                      console.log(roomevents)
                      for(let i=0; i<roomevents.length ; i++){
                        this.totalroomevents.push(roomevents[i])  ;
                      }
                      //Walking Track
                    this.getdataService.getGoogleCalendarData('1on0f3l9ihckaqu7s2rm15m5bg@group.calendar.google.com').subscribe((roomevents) => {
                      console.log(roomevents)
                      for(let i=0; i<roomevents.length ; i++){
                        this.totalroomevents.push(roomevents[i])  ;
                      }
                       //Healing waters
                    this.getdataService.getGoogleCalendarData('b9tc418r4ne8nm8rt4h5spj1as@group.calendar.google.com').subscribe((roomevents) => {
                      console.log(roomevents)
                      for(let i=0; i<roomevents.length ; i++){
                        this.totalroomevents.push(roomevents[i])  ;
                      }
                      //Leisure swim
                     this.getdataService.getGoogleCalendarData('ih5jo9lt14c9h12tjhahl7oa54@group.calendar.google.com').subscribe((roomevents) => {
                      console.log(roomevents)
                      for(let i=0; i<roomevents.length ; i++){
                        this.totalroomevents.push(roomevents[i])  ;
                      } 
                       //Gentle Waterfit
                      this.getdataService.getGoogleCalendarData('t15uc7fh7e4itcuicvt0t9mv4c@group.calendar.google.com').subscribe((roomevents) => {
                       console.log(roomevents)
                       for(let i=0; i<roomevents.length ; i++){
                         this.totalroomevents.push(roomevents[i])  ;
                       }
                       //Waterfit
                      this.getdataService.getGoogleCalendarData('bple17l0s0sv205bl1kisftn6k@group.calendar.google.com').subscribe((roomevents) => {
                        console.log(roomevents)
                        for(let i=0; i<roomevents.length ; i++){
                          this.totalroomevents.push(roomevents[i])  ;
                        }
                        //Deep end Waterfit
                      this.getdataService.getGoogleCalendarData('eeepp9pdpsa5v8l9b8kjavtkcc@group.calendar.google.com').subscribe((roomevents) => {
                        console.log(roomevents)
                        for(let i=0; i<roomevents.length ; i++){
                          this.totalroomevents.push(roomevents[i])  ;
                        } 
                        //Family swim
                        this.getdataService.getGoogleCalendarData('4p3l25a79h04bln1r5covn4h7s@group.calendar.google.com').subscribe((roomevents) => {
                          console.log(roomevents)
                          for(let i=0; i<roomevents.length ; i++){
                            this.totalroomevents.push(roomevents[i])  ;
                          }
                          //Length swim
                        this.getdataService.getGoogleCalendarData('htuvsnu9udckdoq3p264rahhtc@group.calendar.google.com').subscribe((roomevents) => {
                          console.log(roomevents)
                          for(let i=0; i<roomevents.length ; i++){
                            this.totalroomevents.push(roomevents[i])  ;
                          }
                          //OAC Rental
                        this.getdataService.getGoogleCalendarData('dkdfb9jllhrqreui4fv4l7g2gk@group.calendar.google.com').subscribe((roomevents) => {
                          console.log(roomevents)
                          for(let i=0; i<roomevents.length ; i++){
                            this.totalroomevents.push(roomevents[i])  ;
                          }
                          //Masters Rental
                        this.getdataService.getGoogleCalendarData('m3k3gbkqtoghd9jqq6e107j870@group.calendar.google.com').subscribe((roomevents) => {
                          console.log(roomevents)
                          for(let i=0; i<roomevents.length ; i++){
                            this.totalroomevents.push(roomevents[i])  ;
                          }
                          //Multiple Children’s Lessons
                        this.getdataService.getGoogleCalendarData('v8h0bjmemlt2oal1m0b0l6p204@group.calendar.google.com').subscribe((roomevents) => {
                          console.log(roomevents)
                          for(let i=0; i<roomevents.length ; i++){
                            this.totalroomevents.push(roomevents[i])  ;
                          }
                          //Multiple Leadership Classes
                        this.getdataService.getGoogleCalendarData('nqjop2gr80lae4m1s67uf2r790@group.calendar.google.com').subscribe((roomevents) => {
                          console.log(roomevents)
                          for(let i=0; i<roomevents.length ; i++){
                            this.totalroomevents.push(roomevents[i])  ;
                          }  
                          //Endurance Training
                          this.getdataService.getGoogleCalendarData('b5j1qkk0kak6i42soak2t7lp8g@group.calendar.google.com').subscribe((roomevents) => {
                            console.log(roomevents)
                            for(let i=0; i<roomevents.length ; i++){
                              this.totalroomevents.push(roomevents[i])  ;
                            }
                            //Therapeutic Exercise classes
                          this.getdataService.getGoogleCalendarData('vpmig1rhl9ft5sp6bc8o5m5nrs@group.calendar.google.com').subscribe((roomevents) => {
                            console.log(roomevents)
                            for(let i=0; i<roomevents.length ; i++){
                              this.totalroomevents.push(roomevents[i])  ;
                            }
                            //Bone and Joint Exercise class
                            this.getdataService.getGoogleCalendarData('32ntoll3pktdjjhrct54fbnjus@group.calendar.google.com').subscribe((roomevents) => {
                              console.log(roomevents)
                              for(let i=0; i<roomevents.length ; i++){
                                this.totalroomevents.push(roomevents[i])  ;
                              }
                              //Synchronized Artistic swimming
                            this.getdataService.getGoogleCalendarData('slc4mrnj5uhasjhi21lteh0aig@group.calendar.google.com').subscribe((roomevents) => {
                              console.log(roomevents)
                              for(let i=0; i<roomevents.length ; i++){
                                this.totalroomevents.push(roomevents[i])  ;
                              }
  

                      console.log("hi")
         console.log(this.totalroomevents)
         this.totalroomevents = this.sortByKey(this.totalroomevents,'start','dateTime');
         this.event_array_arena=[];
         var x=0;
         for(let ei=0; ei<this.totalroomevents.length ; ei++){

          let startDate = new Date(this.totalroomevents[ei].start.dateTime).getTime();
          let endDate = new Date(this.totalroomevents[ei].end.dateTime).getTime();
          console.log("event end date: ",endDate)
          console.log("today will end at: ",currentDate_end)

         if( endDate<currentDate_end)
           {
            console.log("Zig Zag", ei)
            this.event_array_arena[x]={summary:'',startdate:'',enddate:'',displayName:''}
            this.event_array_arena[x].summary=this.totalroomevents[ei].summary;
            this.event_array_arena[x].startdate=startDate.toString();
            this.event_array_arena[x].enddate=endDate.toString();
            this.event_array_arena[x].displayName=this.totalroomevents[ei].organizer.displayName;
            x++;
          }
         }
         console.log(this.event_array_arena)
        //this.totalroomevents=  roomevents;
        this.roomevents_ShooterpadA = [];
        this.roomevents_ShooterpadB = [];
        this.roomevents_Commroom1 = [];
        this.roomevents_Commroom2 = [];
        this.roomevents_arena = [];
        ////console.log(roomevents)
        var x=0;
        var y=0;
        var z=0;
        var c=0;
        var m=0;

        //separate arrays//
        
        for(let i=0; i<this.totalroomevents.length; i++)
        {
          let startDate = new Date(this.totalroomevents[i].start.dateTime).getTime();
          let endDate = new Date(this.totalroomevents[i].end.dateTime).getTime();
          if(startDate>currentDate_start && endDate<currentDate_end && endDate>currentDate)
          {
           if(this.totalroomevents[i].organizer.displayName =='Shooter Pad A')
           {
             console.log("added to shooter Pad A")
            this.roomevents_ShooterpadA.push(this.totalroomevents[i]);
           }else if(this.totalroomevents[i].organizer.displayName =='Shooter Pad B'){
            console.log("added to shooter Pad B")
            this.roomevents_ShooterpadB.push(this.totalroomevents[i]);
           }else if(this.totalroomevents[i].organizer.displayName =='Community Room 1'){
            this.roomevents_Commroom1.push(this.totalroomevents[i]);
           }else if(this.totalroomevents[i].organizer.displayName =='Community Room 2'){
            this.roomevents_Commroom2.push(this.totalroomevents[i]);
           }else{
             console.log("helloo")
            this.roomevents_arena.push(this.totalroomevents[i]);
           }
          }
        }
        
       // this.event_array_arena=[];
        this.roomevents_arena = this.sortByKey(this.roomevents_arena,'start','dateTime');

        for(let i=this.event_counter_arena; i<this.roomevents_arena.length; i++)
         {
           var startDate = new Date(this.roomevents_arena[i].start.dateTime).getTime();
           var endDate = new Date(this.roomevents_arena[i].end.dateTime).getTime();

           if(startDate>currentDate_start && endDate<currentDate_end && endDate>currentDate)
           {
             console.log(this.roomevents_arena[i].summary)
            console.log("ACCEPTED")
            //  this.event_array_arena[x]={Event_id:x,Event_name:'',Event_room:'',Event_start_time_number:0,Event_start_time:'',Event_end_time_number:0,Event_end_time:'',Event_Host_Name:''}
            //  this.event_array_arena[x].Event_name=this.roomevents_arena[i].summary ;
            //  this.event_array_arena[x].Event_room=this.roomevents_arena[i].location;
              // var  date = new Date(startDate);
            //  this.event_array_arena[x].Event_start_time=this.format_time(date).toString();
            //  this.event_array_arena[x].Event_start_time_number = startDate;
            //  date = new Date(endDate);
            //  this.event_array_arena[x].Event_end_time=this.format_time(date).toString() ;
            //  this.event_array_arena[x].Event_end_time_number = endDate;
            //  this.event_array_arena[x].Event_Host_Name=this.roomevents_arena[i].organizer.displayName;
             
             x++;
            
           }
          
         }
        
        //   this.event_counter_arena=this.event_counter_arena+7;
        //  //console.log("counter ",this.event_counter_arena);
        //  //console.log("length ",this.roomevents_arena.length);
        //  if(this.event_counter_arena >= this.event_array_arena.length)
        //  {
        //   this.event_counter_arena=0;
        //  }


   //////////////////////////////////////shooter pads/////////////////////////////////////////////////
         this.event_ShooterpadA=[];
         this.roomevents_ShooterpadA = this.sortByKey(this.roomevents_ShooterpadA,'start','dateTime');

         for(let i=this.event_counter_room; i<this.roomevents_ShooterpadA.length; i++)
         {
           var startDate = new Date(this.roomevents_ShooterpadA[i].start.dateTime).getTime() ;
           var endDate = new Date(this.roomevents_ShooterpadA[i].end.dateTime).getTime();
           ////console.log("start date of the event in general:");
          ////console.log("Check_Start Date: "+startDate);
          ////console.log("Check_currentDate: "+currentDate);

          if(startDate>currentDate_start && endDate<currentDate_end && endDate>currentDate)
          {
            console.log("counting valid events")
            /////event name/////
            console.log("event name");
            console.log(this.roomevents_ShooterpadA[i].summary);
            ////console.log(y);
            this.event_ShooterpadA[y]={Event_id:y,Event_name:'',Event_room:'',Event_start_time_number:0,Event_start_time:'',Event_end_time_number:0,Event_end_time:'',Event_Host_Name:''}
            this.event_ShooterpadA[y].Event_name=this.roomevents_ShooterpadA[i].summary ;
            this.event_ShooterpadA[y].Event_room=this.roomevents_ShooterpadA[i].event_room ;
              var  date = new Date(startDate);
            this.event_ShooterpadA[y].Event_start_time=this.format_time(date).toString();
            this.event_ShooterpadA[y].Event_start_time_number = startDate;
            date = new Date(endDate);
            this.event_ShooterpadA[y].Event_end_time=this.format_time(date).toString() ;
            this.event_ShooterpadA[y].Event_end_time_number = endDate;
            ////console.log(this.event_array_room[y].Event_end_time);
            this.event_ShooterpadA[y].Event_Host_Name=this.roomevents_ShooterpadA[i].event_host_name;
            
            y++;
            //////current meeting fetch////////
            
          }
        }


        
        //this.event_ShooterpadA = this.sortByKey(this.event_ShooterpadA,'Event_start_time_number');


        this.event_ShooterpadB=[];
        this.roomevents_ShooterpadB = this.sortByKey(this.roomevents_ShooterpadB,'start','dateTime');

        for(let i=this.event_counter_room; i<this.roomevents_ShooterpadB.length; i++)
        {
          var startDate = new Date(this.roomevents_ShooterpadB[i].start.dateTime).getTime();
          var endDate = new Date(this.roomevents_ShooterpadB[i].end.dateTime).getTime();
          ////console.log("start date of the event in general:");
         ////console.log("Check_Start Date: "+startDate);
         ////console.log("Check_currentDate: "+currentDate);

         if(startDate>currentDate_start && endDate<currentDate_end && endDate>currentDate)
         {
           console.log("counting valid events")
           /////event name/////
           console.log("event name");
           console.log(this.roomevents_ShooterpadB[i].summary);
           ////console.log(y);
           this.event_ShooterpadB[z]={Event_id:z,Event_name:'',Event_room:'',Event_start_time_number:0,Event_start_time:'',Event_end_time_number:0,Event_end_time:'',Event_Host_Name:''}
           this.event_ShooterpadB[z].Event_name=this.roomevents_ShooterpadB[i].summary ;
           this.event_ShooterpadB[z].Event_room=this.roomevents_ShooterpadB[i].event_room ;
             var  date = new Date(startDate);
           this.event_ShooterpadB[z].Event_start_time=this.format_time(date).toString();
           this.event_ShooterpadB[z].Event_start_time_number = startDate;
           date = new Date(endDate);
           this.event_ShooterpadB[z].Event_end_time=this.format_time(date).toString() ;
           this.event_ShooterpadB[z].Event_end_time_number = endDate;
           ////console.log(this.event_array_room[y].Event_end_time);
           this.event_ShooterpadB[z].Event_Host_Name=this.roomevents_ShooterpadB[i].event_host_name;
           
           z++;
           //////current meeting fetch////////
           
         }
       }
       //this.event_ShooterpadB = this.sortByKey(this.event_ShooterpadB,'Event_start_time_number');
         
       
       //////////////////////////////////////community rooms/////////////////////////////////////////////////
       this.event_Commroom1=[];
       this.roomevents_Commroom1 = this.sortByKey(this.roomevents_Commroom1,'start','dateTime');

       for(let i=this.event_counter_room; i<this.roomevents_Commroom1.length; i++)
       {
         var startDate = new Date(this.roomevents_Commroom1[i].start.dateTime).getTime();
         var endDate = new Date(this.roomevents_Commroom1[i].end.dateTime).getTime();
         ////console.log("start date of the event in general:");
        ////console.log("Check_Start Date: "+startDate);
        ////console.log("Check_currentDate: "+currentDate);

        if(startDate>currentDate_start && endDate<currentDate_end && endDate>currentDate)
        {
          console.log("counting valid events")
          /////event name/////
          console.log("event name");
          console.log(this.roomevents_Commroom1[i].summary);
          ////console.log(y);
          this.event_Commroom1[c]={Event_id:c,Event_name:'',Event_room:'',Event_start_time_number:0,Event_start_time:'',Event_end_time_number:0,Event_end_time:'',Event_Host_Name:''}
          this.event_Commroom1[c].Event_name=this.roomevents_Commroom1[i].summary ;
          this.event_Commroom1[c].Event_room=this.roomevents_Commroom1[i].event_room ;
            var  date = new Date(startDate);
          this.event_Commroom1[c].Event_start_time=this.format_time(date).toString();
          this.event_Commroom1[c].Event_start_time_number = startDate;
          date = new Date(endDate);
          this.event_Commroom1[c].Event_end_time=this.format_time(date).toString() ;
          this.event_Commroom1[c].Event_end_time_number = endDate;
          ////console.log(this.event_array_room[y].Event_end_time);
          this.event_Commroom1[c].Event_Host_Name=this.roomevents_Commroom1[i].event_host_name;
          
          c++;
          //////current meeting fetch////////
          
        }
      }


      
      //this.event_Commroom1 = this.sortByKey(this.event_Commroom1,'Event_start_time_number');


      this.event_Commroom2=[];
      this.roomevents_Commroom2 = this.sortByKey(this.roomevents_Commroom2,'start','dateTime');

      for(let i=this.event_counter_room; i<this.roomevents_Commroom2.length; i++)
      {
        var startDate = new Date(this.roomevents_Commroom2[i].start.dateTime).getTime();
        var endDate = new Date(this.roomevents_Commroom2[i].end.dateTime).getTime();
        ////console.log("start date of the event in general:");
       ////console.log("Check_Start Date: "+startDate);
       ////console.log("Check_currentDate: "+currentDate);

       if(startDate>currentDate_start && endDate<currentDate_end && endDate>currentDate)
       {
         console.log("counting valid events")
         /////event name/////
         console.log("event name");
         console.log(this.roomevents_Commroom2[i].summary);
         ////console.log(y);
         this.event_Commroom2[m]={Event_id:m,Event_name:'',Event_room:'',Event_start_time_number:0,Event_start_time:'',Event_end_time_number:0,Event_end_time:'',Event_Host_Name:''}
         this.event_Commroom2[m].Event_name=this.roomevents_Commroom2[i].summary ;
         this.event_Commroom2[m].Event_room=this.roomevents_Commroom2[i].event_room ;
           var  date = new Date(startDate);
         this.event_Commroom2[m].Event_start_time=this.format_time(date).toString();
         this.event_Commroom2[m].Event_start_time_number = startDate;
         date = new Date(endDate);
         this.event_Commroom2[m].Event_end_time=this.format_time(date).toString() ;
         this.event_Commroom2[m].Event_end_time_number = endDate;
         ////console.log(this.event_array_room[y].Event_end_time);
         this.event_Commroom2[m].Event_Host_Name=this.roomevents_Commroom2[i].event_host_name;
         
         m++;
         //////current meeting fetch////////
         
       }
     }
     //this.event_Commroom2 = this.sortByKey(this.event_Commroom2,'start','dateTime');
       
       
       
      
       
       
       console.log(this.event_ShooterpadB.length)
         console.log(this.event_ShooterpadA);
        },
        err=>{
          //////console.log(err);
          return false;
        });
      },
      err=>{
        //////console.log(err);
        return false;
      });
    },
    err=>{
      //////console.log(err);
      return false;
    });
      },
      err=>{
        //////console.log(err);
        return false;
      });
        },
        err=>{
          //////console.log(err);
          return false;
        });
          },
      err=>{
        //////console.log(err);
        return false;
      });
        },
        err=>{
          //////console.log(err);
          return false;
        });
          },
          err=>{
            //////console.log(err);
            return false;
          });
            },
            err=>{
              //////console.log(err);
              return false;
            });
              },
              err=>{
                //////console.log(err);
                return false;
              });
                },
                err=>{
                  //////console.log(err);
                  return false;
                });
                  },
                  
                  err=>{
                    //////console.log(err);
                    return false;
                  });
                    },
                    err=>{
                      //////console.log(err);
                      return false;
                    });
                      },
                      err=>{
                        //////console.log(err);
                        return false;
                      });
                        },
                        err=>{
                          //////console.log(err);
                          return false;
                        });
                          },
                          err=>{
                            //////console.log(err);
                            return false;
                          });
                            },
                            err=>{
                              //////console.log(err);
                              return false;
                            });
                              },
                              err=>{
                                //////console.log(err);
                                return false;
                              });
                                },
                                err=>{
                                  //////console.log(err);
                                  return false;
                                });
                                
                                  },
                                  err=>{
                                    //////console.log(err);
                                    return false;
                                  });
                                  
                                    },
                                    err=>{
                                      //////console.log(err);
                                      return false;
                                    });
                                    
                                      },
                                  err=>{
                                    //////console.log(err);
                                    return false;
                                  });
                                    },
                                    err=>{
                                      //////console.log(err);
                                      return false;
                                    });
                                      },
                                      err=>{
                                        //////console.log(err);
                                        return false;
                                      });
                                        },
                                        err=>{
                                          //////console.log(err);
                                          return false;
                                        });
                                          },
                                          err=>{
                                            //////console.log(err);
                                            return false;
                                          });
                                            },
      err=>{
        //////console.log(err);
        return false;
      });
    }
    
   


   sortByKey(array, key,subkey) {
    return array.sort(function(a, b) {
        var x = a[key][subkey]; var y = b[key][subkey];
        return ((x < y) ? -1 : ((x > y) ? 1 : 0));
    });
}

}



interface RoomEvents{
  _id:number,
  event_name:string,
  summary:string,
  organizer,
  start,
  end,
  location,
  event_room:string,
  event_room_id:string,
  event_place:string,
  event_start_time:Date,
  event_start_time_readable:string,
  event_end_time_readable:string,
  event_end_time:Date,
  event_logo:string,
  event_logo_path:string,
  event_host_name:string,
  event_attendants:string[]
}


interface Event_array_arena{
  summary:string,
  startdate:string,
  enddate:string,
  displayName:string,

}

interface Event_array_room{
  Event_id:number,
  Event_name:string,
  Event_room:string,
  Event_start_time:string,
  Event_start_time_number:number,
  Event_end_time:string,
  Event_end_time_number:number,
  Event_Host_Name:string
}


// WEBPACK FOOTER //
// ./src/app/components/southeast-community/southeast-community.component.ts